import clsx from "clsx";

type FocusRingProps = {
  /** Use the inverted (light-on-dark) border color. Default: false. */
  inverted?: boolean;
};

/**
 * Focus ring, absolutely positioned outside the parent element's bounds, per
 * design spec. The parent element must set `group relative` (or `group`
 * plus its own positioning) for this to align correctly.
 */
export const FocusRing = ({ inverted = false }: FocusRingProps) => (
  <span
    aria-hidden="true"
    className={clsx(
      "pointer-events-none absolute -inset-1 rounded-lg border-2 border-solid opacity-0 group-focus-visible:opacity-100",
      inverted ? "border-border-primary-inverse" : "border-border-primary",
    )}
  />
);
